import { APP_STORE_URL } from "@/lib/appStore";
import mascot from "@/assets/mascot-happy-224.png";

export function AppDownloadCTA() {
  return (
    <section className="rounded-2xl bg-[hsl(var(--primary))] p-8 text-center text-[hsl(var(--primary-foreground))] sm:p-10">
      <div className="mx-auto flex h-14 w-14 items-center justify-center overflow-hidden rounded-full bg-[hsl(var(--secondary)/0.2)]">
        <img
          src={mascot}
          alt="The Grounded mascot"
          className="h-11 w-11 object-contain"
          loading="lazy"
        />
      </div>
      <h2 className="mt-4 font-serif text-2xl font-semibold sm:text-3xl">
        Find your next work spot anywhere
      </h2>
      <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed opacity-90 sm:text-base">
        Download Grounded for iOS to discover Wi-Fi-friendly cafés, check in,
        and track your favorite spots.
      </p>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-[hsl(var(--secondary))] px-6 py-3 font-medium text-[hsl(var(--secondary-foreground))] transition hover:brightness-105"
      >
        Download on the App Store
      </a>
    </section>
  );
}
